
import { Loader2 } from "lucide-react";

interface LoadingIndicatorProps {
  processingImages?: Set<string>;
  message?: string;
  isSaving?: boolean;
  timeoutError?: boolean;
}

export const LoadingIndicator = ({ 
  processingImages, 
  message, 
  isSaving,
  timeoutError 
}: LoadingIndicatorProps) => {
  if (!isSaving && (!processingImages || processingImages.size === 0)) return null;

  return (
    <div className="absolute top-4 right-4 z-50 bg-white/80 backdrop-blur-sm rounded-lg px-4 py-2 flex items-center gap-2 shadow-sm">
      <Loader2 className={`h-4 w-4 ${timeoutError ? 'text-red-500' : ''} animate-spin`} />
      <span className={`text-sm ${timeoutError ? 'text-red-600' : 'text-gray-700'}`}>
        {timeoutError 
          ? "Save operation timed out..." 
          : (message || (processingImages && processingImages.size > 0
              ? `Processing image${processingImages.size > 1 ? 's' : ''}...` 
              : 'Loading...'))}
      </span>
    </div>
  );
};
